export const getStores = async (_, apiService) => {
  try {
    const { user } = apiService.extra.apiService;
    const response = await user.get("/fnbproduct/store");
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTerminals = async (_, apiService) => {
  try {
    const { user } = apiService.extra.apiService;
    const response = await user.get("/fnbproduct/terminal");
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
